import type { CitationSummary, RunSummary, TelemetryApplication } from "../../shared/telemetry.js";

export const demoApplications: TelemetryApplication[] = [
  {
    schema_version: 1,
    application: "briefaudit",
    display_name: "BriefAudit",
    operations: [{ id: "citation-audit", workflows: [], event_types: ["citation_audit.completed"] }]
  },
  {
    schema_version: 1,
    application: "scipubaudit",
    display_name: "SciPubAudit",
    operations: [
      {
        id: "citation-audit",
        workflows: ["document-upload", "pmcid"],
        event_types: ["citation_audit.completed"]
      }
    ]
  },
  {
    schema_version: 1,
    application: "example-app",
    display_name: "Example experiment (demo)",
    operations: [{ id: "analysis", workflows: [], event_types: ["application.run.completed"] }]
  }
];
const end = Date.parse("2026-09-21T00:00:00Z");
const day = (offset: number) => new Date(end - offset * 86_400_000).toISOString().slice(0, 10);
const range = (days: number) => ({ start: day(days), end: day(0), days });
// Synthetic daily counts: a weekly rhythm, with weekends and a quiet spell below the floor of 5
// left out, as the service leaves them out.
function demoDaily(days: number) {
  return Array.from({ length: days + 1 }, (_, i) => days - i).map((offset) => {
    const weekday = new Date(`${day(offset)}T12:00:00Z`).getUTCDay();
    const runs =
      weekday === 0 || weekday === 6 || (offset >= 9 && offset <= 11) ? 3 : 8 + ((offset * 7) % 11);
    const failed = Math.floor(runs / 7);
    return {
      date: day(offset),
      runs,
      succeeded: runs - failed,
      failed,
      cancelled: 0,
      success_rate: (runs - failed) / runs,
      average_duration_seconds: 92
    };
  });
}
export function demoRuns(days: number, application: string): RunSummary {
  const all = demoDaily(days);
  const sum = (key: "runs" | "succeeded" | "failed" | "cancelled") =>
    all.reduce((total, row) => total + row[key], 0);
  const overall = {
    runs: sum("runs"),
    succeeded: sum("succeeded"),
    failed: sum("failed"),
    cancelled: sum("cancelled"),
    success_rate: sum("succeeded") / sum("runs"),
    average_duration_seconds: 92
  };
  return {
    range: range(days),
    filters: {},
    cohort_floor: 5,
    overall,
    by_application: [{ ...overall, application: application || "briefaudit" }],
    by_operation: [],
    by_workflow: [],
    daily: all.filter((row) => row.runs >= 5)
  };
}
export function demoCitations(days: number, application: string): CitationSummary {
  const overall = {
    runs: 42,
    total: 500,
    verified: 350,
    partial: 70,
    unverified: 60,
    skipped: 20,
    type_a: 25,
    type_a_rate: 0.05,
    average_duration_seconds: 92
  };
  return {
    range: range(days),
    filters: {},
    cohort_floor: 5,
    overall,
    by_application: [{ ...overall, application: application || "briefaudit" }],
    daily: []
  };
}
